import React from "react";

export interface ReleaseNote {
  version: string;
  notes: React.ReactNode[];
  date: string;
}

const VERSION_STORAGE_KEY = "lastSeenVersion";

export const versionService = {
  getCurrentVersion: (): string => {
    const metaTag = document.querySelector('meta[name="version"]');
    return metaTag?.getAttribute("content") || "0.0.0";
  },

  getLastSeenVersion: (): string | null => {
    return localStorage.getItem(VERSION_STORAGE_KEY);
  },

  setLastSeenVersion: (version: string): void => {
    localStorage.setItem(VERSION_STORAGE_KEY, version);
  },

  shouldShowReleaseNotes: (currentVersion: string): boolean => {
    const lastSeenVersion = versionService.getLastSeenVersion();
    return !lastSeenVersion || lastSeenVersion !== currentVersion;
  },
};

// Hardcoded release notes for each version
export const RELEASE_NOTES: Record<string, Omit<ReleaseNote, "version">> = {
  "2025.06.11": {
    date: "June 11, 2025",
    notes: [
      "Release notes view",
      "Enhanced dashboard interface",
      "Added new correlation analysis features",
      "More data in Correlation tooltip",
      "Automation HealthChecks status",
    ],
  },
  "2025.06.17": {
    date: "June 17, 2025",
    notes: [
      "Added date annotations for roll start/stop in COT Analysis",
      "Security Updates",
    ],
  },
  "2025.06.26": {
    date: "June 26, 2025",
    notes: ["New Roll Strength view in COT Analysis"],
  },
  "2025.07.01": {
    date: "July 1, 2025",
    notes: [
      "View Historical Roll Dates in COT Root Details",
      "Added MM Net Change to COT Survey Page",
    ],
  },
  "2025.07.14": {
    date: "July 14, 2025",
    notes: [
      "Table view released in Roll Strength View",
      "Improved filtering on roll volume data",
      "Roll dates available for all roots with data",
    ],
  },
  "2025.08.07": {
    date: "August 7, 2025",
    notes: [
      "View COT rank data ungrouped in COT Analysis",
      "Added date annotations to roll volume data",
      "Added relative change to COT Analysis",
      "Added MM strength histogram to root details page",
    ],
  },
  "2025.10.15": {
    date: "October 15, 2025",
    notes: ["New ranked view of correlation data pairs"],
  },
  "2025.10.28": {
    date: "October 28, 2025",
    notes: ["Experimental🧪: New Option Selection view in Volatility Analysis"],
  },
  "2025.12.01": {
    date: "December 1, 2025",
    notes: ["New Data and Features in Volatility Analysis Page!"],
  },
  "2026.03.12": {
    date: "March 12, 2026",
    notes: [
      "New IRR Analysis Page!🎉",
      " - View current IRR data",
      " - Compare past IRR's near expiry",
      "Added ivol forward curve view in Volatility Analysis Page",
    ],
    
  },
  "2026.06.02": {
    date: "June 2, 2026",
    notes: [
      "New sort metric config system in COT Analysis",
      <>COT root details are now bookmarkable — <a href="/COT-analysis/ZC">try it out</a></>,
      "Minor fixes to Roll Strength View"
    ],
  },
  "2026.06.16": {
    date: "June 16, 2026",
    notes: [
      "New historical open interest view in COT Analysis",
      "Redesigned COT Analysis page 🎉",
    ],
  },
  // Add more versions here as needed
};

export default versionService;
